<div class="particles-container flex items-center justify-center">
  <ngx-particles
    id="trade-modal-particles"
    [options]="particlesOptions"
  ></ngx-particles>
</div>
<svg-icon
  class="trade--steam-icon"
  [svgStyle]="{ width: '40px', height: '40px',  }"
  src="assets/icons/ui/steam.svg"
/>
<h2 class="trade--title typography-title">Withdraw</h2>
<p class="trade--description" style="color: var(--gray)">
  Your withdrawal of
  <app-cost [balanceType]="balancetype()" [cost]="value()" [gap]="4"></app-cost>
  is being sent
</p>
<div class="trade--items">
  @for (item of skinsWithImages().slice(0, 4); track $index) {
  <div class="trade--item box-white-04 hover">
    <img [src]="item.image" [alt]="item.name" loading="lazy" />
  </div>
  } @let remainingSkins = skinsWithImages().length - 4; @if (remainingSkins > 0)
  {
  <div class="trade--item box-yellow-08 hover" style="cursor: pointer">
    +{{ remainingSkins }}
  </div>
  }
</div>

<div class="buttons">
  <a
    [routerLink]="['/withdraw']"
    (click)="closeModal()"
    class="back-store--button button button--style-yellow padding-x-12 h-38"
  >
    Back to Store
  </a>
  <a
    [href]="`https://steamcommunity.com/tradeoffer/${offerid()}/`"
    target="_blank"
    class="trade--button button button--style-blue padding-x-12 h-38"
  >
    Accept Offer
  </a>
</div>
<p (click)="clipboardService.copy(hash(), 'Hash copied!')" class="trade--hash">
  Hash: {{ hash() }}
</p>
